import { connect } from 'react-redux';
import { setSidebarToggleMobile } from '../../../store/reducers/ThemeOptions';
import HeaderUserbox from '../../layout-components/HeaderUserbox';
import { makeStyles } from 'tss-react/mui';
import { ConnectionStatusIndicator } from '../../../components/ConnectionStatusIndicator';
import { FiArrowUpRight, FiMenu } from 'react-icons/fi';

const useStyles = makeStyles()((theme) => ({

}))

const Header = (props) => {
    const { classes, cx } = useStyles();
    const {
        headerShadow,
        headerBgTransparent,
        sidebarToggleMobile,
        setSidebarToggleMobile,
        settings
    } = props;

    const openVendorWebsite = () => {
        window.open("https://" + settings.ClientWebPortalBaseUrl);
    };

    const toggleSidebarMobile = () => {
        setSidebarToggleMobile(!sidebarToggleMobile);
    };

    // Like the client portal: a thin strip at the top with the link to the client portal, then the bar with the
    // connection indicator next to the avatar on the right.
    return (
        <div
            className={cx('app-header pb-header', {
                'app-header--shadow': headerShadow,
            })}>
            <div className="pb-topbar">
                {settings?.ClientWebPortalBaseUrl && <a onClick={openVendorWebsite} className="pb-topbar-link" role="link" tabIndex={0}>
                    Go to {settings.ClientWebPortalBaseUrl} <FiArrowUpRight />
                </a>}
            </div>
            <div className="pb-header-bar">
            <div className="app-header--pane">
                {/* Phones: open the menu. */}
                <button
                    className={cx(
                        'navbar-toggler toggle-mobile-sidebar-btn pb-menu-btn',
                        { 'is-active': sidebarToggleMobile }
                    )}
                    aria-label="Open menu"
                    onClick={toggleSidebarMobile}>
                    <FiMenu />
                </button>
            </div>
            <div className="app-header--pane">
                <ConnectionStatusIndicator />
                <HeaderUserbox />
            </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    headerShadow: state.ThemeOptions.headerShadow,
    headerBgTransparent: state.ThemeOptions.headerBgTransparent,
    sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
    settings: state.settings.settings
});

const mapDispatchToProps = (dispatch) => ({
    setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
